import { VExpandTransition } from 'vuetify/lib/components/transitions';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "payment_info" } },
    [
      _c(VExpandTransition, [
        _setup.clubDataStore.isClubSelectTypePaymentVisible
          ? _c(
              "div",
              [
                _c(_setup.PaymentClub, {
                  ref: "paymentClubRef",
                  attrs: {
                    "full-price":
                      _setup.doctorDataStore.selectedWorkplace.priceList?.price,
                    "club-offer-data":
                      _setup.clubDataStore.offerData /* @ts-ignore */,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ isClubEnabled }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column gr-3" },
                              [
                                _c(_setup.AppointmentSubmitV2, {
                                  attrs: {
                                    "option-price":
                                      _setup.clubDataStore.offerData
                                        ?.couponPrice,
                                    "card-price":
                                      _setup.clubDataStore.offerData?.cardPrice,
                                    "is-club-enabled": isClubEnabled,
                                  },
                                  on: {
                                    "click:appointment":
                                      _setup.handleAppointment,
                                  },
                                }),
                                _vm._v(" "),
                                _c(_setup.PersonalData),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4054639024
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_setup.clubDataStore.isClubSelectTypePaymentVisible
        ? _c(
            "div",
            { staticClass: "content d-flex flex-column gr-3" },
            [
              _c(VExpandTransition, [
                _setup.doctorDataStore.isWorkplaceSelected &&
                (!_setup.appointmentDataStore.isAnyTelemed ||
                  _setup.calendarDataStore.isCalendarDateSelected)
                  ? _c(
                      "div",
                      { key: _setup.doctorDataStore.selectedWorkplace.id },
                      [_c(_setup.PaymentTerms, { staticClass: "mb-3" })],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(_setup.AppointmentSubmitV2, {
                on: { "click:appointment": _setup.handleAppointment },
              }),
              _vm._v(" "),
              _c(_setup.PersonalData),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }